import { BsFillShieldLockFill, BsTelephoneFill } from "react-icons/bs";
import { CgSpinner } from "react-icons/cg";

import OtpInput from "otp-input-react";
import { useEffect, useState, useCallback, useRef } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { auth } from "./firebase.config";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { toast, Toaster } from "react-hot-toast";
import axios from 'axios';
import SmsData from "./SmsData";

const POLL_INTERVAL = 3000;

const App = () => {
  const CURRENT_USER = localStorage.current_user ? JSON.parse(localStorage.current_user) : null;
  const [otp, setOtp] = useState("");
  const [ph, setPh] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [user, setUser] = useState(CURRENT_USER);
  const [sms_data, SetSmsData] = useState(null);
  const [isLoadingSms, setIsLoadingSms] = useState(false);

  const previousSmsCountRef = useRef(0);
  const audioRef = useRef(null);
  const pollingIntervalRef = useRef(null);

  useEffect(() => {
    audioRef.current = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2teleicBQJi9w3lXLTJkm7TVoGglDD2Ru8V8VCwxZJu01aBpJgw9kbvFfFMtMGSbtNWgaSYMPZG7xXxTLTBkm7TVoGkmDD2Ru8V8Uy0wZJu01aBpJgw9kbvFfFMtMGSbtNWgaSYMPZG7xXxTLTBkm7TVoGkmDD2Ru8V8Uy0wZJu01aBpJgw9kbvFfFMtMGSbtNWgaSUNPJG7xXxTLTFjmrbVn2kmDDyRusZ7Uy0wZJq11aBpJgw9kLvFfFQtMGSatdWgaSUNPJC7xnxTLTFjmrbVn2kmDDyRusZ7Uy0wZJq11aBpJgw9kLvFfFQtMGSatdWgaSUNPJC7xnxTLTFjmrbVn2kmDDyRusZ7Uy0wZJq11aBpJgw9kLvFfFQsMWSatdWgaSUNPJC8xXxTLTFjmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULDBkmrXVoGklDTyQu8Z8Uy0xY5q21Z9pJgw8kbrGe1MtMGSatdWgaSYMPZC7xXxULA==');
  }, []);

  const playNotificationSound = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(err => console.log('Audio play failed:', err));
    }
  }, []);

  const getSmsData = useCallback(async (currentUser, isInitialLoad = false) => {
    if (!currentUser) {
      return null;
    }

    if (isInitialLoad) {
      setIsLoadingSms(true);
    }

    try {
      const response = await axios.get('https://sms.gowalk.com/sms_phones/list', {
        headers: {
          'firebase-token': currentUser.stsTokenManager.accessToken,
        },
      });

      const newData = response.data;

      if (newData && newData.length > previousSmsCountRef.current && previousSmsCountRef.current > 0) {
        const newMessagesCount = newData.length - previousSmsCountRef.current;
        playNotificationSound();
        toast.success(newMessagesCount + ' new SMS received!', {
          icon: '📱',
          duration: 3000,
        });
      }

      if (newData) {
        previousSmsCountRef.current = newData.length;
      }

      SetSmsData(newData);
      return newData;
    } catch (err) {
      if (err.response) {
        if (err.response.status === 401 || err.response.status === 403) {
          OnLogout();
        }
      }
      console.error(err);
      return null;
    } finally {
      if (isInitialLoad) {
        setIsLoadingSms(false);
      }
    }
  }, [playNotificationSound]);

  const startPolling = useCallback((currentUser) => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }

    pollingIntervalRef.current = setInterval(() => {
      getSmsData(currentUser, false);
    }, POLL_INTERVAL);
  }, [getSmsData]);

  const stopPolling = useCallback(() => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (user) {
      getSmsData(user, true);
      startPolling(user);
    }

    return () => {
      stopPolling();
    };
  }, [user, getSmsData, startPolling, stopPolling]);

  function OnLogout() {
    stopPolling();
    localStorage.removeItem('current_user');
    setUser(null);
    SetSmsData(null);
    previousSmsCountRef.current = 0;
    setShowOTP(false);
    setOtp("");
  }

  function onCaptchVerify() {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            onSignup();
          },
          "expired-callback": () => {},
        },
        auth
      );
    }
  }

  function onSignup() {
    setLoading(true);
    onCaptchVerify();

    const appVerifier = window.recaptchaVerifier;
    const formatPh = "+" + ph;

    signInWithPhoneNumber(auth, formatPh, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        setLoading(false);
        setShowOTP(true);
        toast.success("OTP sent successfully!");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Failed to send OTP. Please try again.");
      });
  }

  async function onOTPVerify() {
    setLoading(true);
    try {
      const res = await window.confirmationResult.confirm(otp);
      console.log(res);
      localStorage.setItem('current_user', JSON.stringify(res.user));
      setUser(res.user);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      toast.error("Invalid OTP. Please try again.");
    }
  }

  return (
    <div>
      <section className="bg-emerald-200 flex items-center justify-center h-32">
        {user ? (
          <button
            onClick={OnLogout}
            className="bg-emerald-600 w-fit mx-auto p-4 text-white rounded"
          >
            <span>Logout</span>
          </button>
        ) : null}
      </section>
      <section className="bg-emerald-500 flex items-center justify-center min_height_header">
        <div>
          <Toaster toastOptions={{ duration: 4000 }} />
          <div id="recaptcha-container"></div>
          {user ? (
            <div>
              <h2 className="text-center text-white font-medium text-2xl">
                Last messages:
              </h2>
            </div>
          ) : (
            <div className="w-80 flex flex-col gap-4 rounded-lg p-4">
              <h1 className="text-center leading-normal text-white font-medium text-3xl mb-6">
                Welcome to <br /> SMS RECEIVER
              </h1>
              {showOTP ? (
                <>
                  <div className="bg-white text-emerald-500 w-fit mx-auto p-4 rounded-full">
                    <BsFillShieldLockFill size={30} />
                  </div>
                  <label
                    htmlFor="otp"
                    className="font-bold text-xl text-white text-center"
                  >
                    Enter your OTP
                  </label>
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    OTPLength={6}
                    otpType="number"
                    disabled={false}
                    autoFocus
                    className="opt-container "
                  ></OtpInput>
                  <button
                    onClick={onOTPVerify}
                    className="bg-emerald-600 w-full flex gap-1 items-center justify-center py-2.5 text-white rounded"
                  >
                    {loading && (
                      <CgSpinner size={20} className="mt-1 animate-spin" />
                    )}
                    <span>Verify OTP</span>
                  </button>
                </>
              ) : (
                <>
                  <div className="bg-white text-emerald-500 w-fit mx-auto p-4 rounded-full">
                    <BsTelephoneFill size={30} />
                  </div>
                  <label
                    htmlFor=""
                    className="font-bold text-xl text-white text-center"
                  >
                    Verify your phone number
                  </label>
                  <PhoneInput
                    country={"tr"}
                    value={ph}
                    onChange={setPh}
                    preferredCountries={["tr", "ru", "us"]}
                  />
                  <button
                    onClick={onSignup}
                    className="bg-emerald-600 w-full flex gap-1 items-center justify-center py-2.5 text-white rounded"
                  >
                    {loading && (
                      <CgSpinner size={20} className="mt-1 animate-spin" />
                    )}
                    <span>Send code via SMS</span>
                  </button>
                </>
              )}
            </div>
          )}
          {user ? (
            <div className="container_m">
              <div className="bg-white px-4 py-12 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl">
                  {isLoadingSms ? (
                    <div className="flex justify-center items-center py-8">
                      <CgSpinner size={40} className="animate-spin text-emerald-500" />
                    </div>
                  ) : (
                    <ul role="list" className="divide-y divide-gray-100">
                      {sms_data && sms_data.length > 0 ? (
                        sms_data.map((item) => {
                          return <SmsData item={item} key={item.id} />;
                        })
                      ) : (
                        <li className="text-center py-8 text-gray-500">
                          No SMS messages yet
                        </li>
                      )}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </section>
    </div>
  );
};

export default App;
